const _extends = Object.assign || function (target, ...sources) {
	sources.forEach(source => {
		if (source != null) { // Check if source is not null or undefined
			Object.keys(source).forEach(key => {
				target[key] = source[key];
			});
		}
	});
	return target;
};

import React from 'react';

const createIconComponent = function createIconComponent({content, height, width}) {
	return function (props) {
		return React.createElement('svg', _extends(
			{},
			props,
			{
				style: _extends({}, styles.root, props.style),
				viewBox: `0 0 ${width} ${height}`,
				role: 'img',
				'aria-hidden': 'true'
			}), content);
	};
};

const styles = {
	root: {
		// display: 'inline-block',
		// fill: 'currentcolor',
		height: '1.25em',
		maxWidth: '100%',
		position: 'relative',
		userSelect: 'none',
		textAlignVertical: 'text-bottom'
	}
};

export default createIconComponent;
